import { render, staticRenderFns } from "./FileChatMessage.vue?vue&type=template&id=41da3f7e"
import script from "./FileChatMessage.vue?vue&type=script&lang=js"
export * from "./FileChatMessage.vue?vue&type=script&lang=js"
import style0 from "./FileChatMessage.vue?vue&type=style&index=0&id=41da3f7e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports